import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
const [ w, d, l, mq ] = [ window, document, location, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  gsap.registerPlugin( ScrollTrigger )
}

const documentReady = () => {
  
  const parallax = () => {
    let $boxes = $('[data-plugin="parallax"]')
    $boxes.each( (i,obj) => {
      gsap.fromTo( obj, {
        y: '0'
      },{
        y: obj.dataset.duration+"px" || '10vh',
        // yPercent: 100 * parseFloat( obj.dataset.speed || 1 ),
        // xPercent: -100 * parseFloat( obj.dataset.speed || 1 ),
        scrollTrigger: {
          trigger: obj,
          start: `top ${obj.dataset.startAt || 'top'}`, // the default values
          end: `+=${window.innerHeight + ( parseInt(obj.dataset.duration) + parseInt(obj.clientHeight) + parseInt(obj.clientHeight) ) }px`,
          scrub: true, // アニメーションをスクロール位置にリンクさせる
          markers: (obj.dataset.marker == 'true'), // マーカー表示
          onEnter: () => false,
          onEnterBack: () => false,
          onLeave: () => false,
          onLeaveBack: () => false
        }
      })
    })
  }

  $.when( w.load['loadHtml'] ).then( () => {
    ScrollTrigger.matchMedia({
      "(min-width: 900px)"() { parallax() }
    })
  })
}

export default function ABOUT () {
  init()
  $( documentReady )
}